<template>
  <div class="animated fadeIn">
    <b-tabs>
      <b-tab title="Daily Report" active class="text-center">
        <h4>Daily Report</h4>
      <hr>
      <b-form inline style="justify-content: space-between">
        <div style="display: flex; flex-direction: row;">
          <datepicker
            v-model="date"
          />
          <b-button size="md" variant="success" @click="generateDailyReport">
            Generate Report
          </b-button>
        </div>
        <b-button size="md" variant="outline-success" class="float-right" :disabled="daily.syncToHarmonyLoading" @click="syncToHarmony" style="display: none;">
          <b-spinner small v-if="daily.syncToHarmonyLoading"></b-spinner>
          Sync to Harmony
        </b-button>
      </b-form>
      <div class="table-container my-4" v-if="daily.transactions.length > 0">
        <table class="table" id="table-daily">
          <thead>
            <tr>
              <td rowspan="2">No</td>
              <td rowspan="2">Transaction Creation Date</td>
              <td rowspan="2">Transaction Date</td>
              <td rowspan="2">Transaction ID</td>
              <td rowspan="2">Invoice Number</td>
              <td rowspan="2">Barista Name</td>
              <td rowspan="2">Payment Type</td>
              <td rowspan="2">Discount Reason</td>
              <td colspan="7">Detail</td>
              <td rowspan="2">Service Fee</td>
              <td rowspan="2">Rounding</td>
              <td rowspan="2">Grand Total</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>Quantity</td>
              <td>Price</td>
              <td>Discount</td>
              <td>Adds On</td>
              <td>Tax</td>
              <td>Sub Total</td>
            </tr>
          </thead>
          <tbody>
          <template
            v-for="(transaction, key) in daily.transactions"
            :class="{ odd: key % 2==0 }"
          >
            <template v-if="false">
              <tr
                v-if="key !== 0"
                :key="transaction.id"
              >
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Name</td>
                <td>Quantity</td>
                <td>Price</td>
                <td>Discount</td>
                <td>Adds On</td>
                <td>Tax</td>
                <td>Sub Total</td>
                <td></td>
              </tr>
            </template>
            <tr
              v-for="(product, idx) in transaction.products"
              :key="`${transaction.id}-${product.id}`"
            >
              <td><template v-if="idx === 0">{{ key + 1 }}</template></td>
              <td title="transaction.created_at"><template v-if="idx === 0">{{ transaction.created_at }}</template></td>
              <td title="transaction.finished_ts"><template v-if="idx === 0">{{ transaction.finished_ts }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.id }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.invoice_number }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.user.name }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.payment }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.discount_reason || '-' }}</template></td>
              <td class="text-left">{{ product.name }}</td>
              <td>{{ product.pivot.quantity }}</td>
              <td>{{ product.pivot.price | price }}</td>
              <td>{{ product.pivot.discount }} %</td>
              <td>{{ product.pivot.additional_price | price }}</td>
              <td>{{ product.pivot.tax }}</td>
              <td>{{ product.pivot.final_price | price }}</td>
              <td class="no-wrap"><template v-if="idx === 0">{{ transaction.service_fee }}</template></td>
              <td class="no-wrap"><template v-if="idx === 0">{{ transaction.rounding }}</template></td>
              <td class="no-wrap"><template v-if="idx === 0">{{ transaction.subTotal | currency }}</template></td>
            </tr>
          </template>
          <tr>
            <td colspan="15" class="text-right">
              Total Income
            </td>
            <td class="total-price no-wrap">
              {{ daily.totalPrice | currency }}
            </td>
          </tr>
          <template v-if="daily.paymentMethods">
            <tr v-for="(method, index) in daily.paymentMethods" :key="index">
              <td colspan="12" class="text-right">
                Total {{ method.name }}
              </td>
              <td class="total-price no-wrap">
                {{ method.value | currency }}
              </td>
            </tr>
          </template>
          </tbody>
        </table>
        <div class="my-2" v-if="daily.isAvailableForExcel">
          <b-button size="md" variant="info" @click="downloadAsExcelDaily(false)">
            Show Download's Optional Buttons
          </b-button>
        </div>
        <div class="my-2">
          <b-button size="md" variant="info" @click="downloadJson()">
            Download Report Raw
          </b-button>
        </div>
      </div>
      <div class="my-4" v-else-if="daily.transactions.length > 0" v-show="daily.isLoaded">
        <h4>Oops, it looks like there are no transactions that can be shown</h4>
      </div>
      <div class="table-container my-4" v-if="daily.productSales.length > 0">
        <table class="table" id="table-daily-product-sales">
          <thead>
          <tr class="table-header text-center bold">
            <td colspan="3">Popular Products on {{ date | moment('DD MMMM YYYY') }} at {{ activeOutlet }}</td>
          </tr>
          </thead>
          <tbody>
          <tr class="table-header">
            <td class="no">No</td>
            <td class="date">Product/Beverages Name</td>
            <td class="total-sales">Sales Quantity</td>
          </tr>
          <tr
            v-for="(product, key) in daily.productSales"
            v-bind:class="{ odd: key%2==0 }"
            :key="`${key}`"
          >
            <td>{{ (key + 1) }}</td>
            <td>{{ product.productName }}</td>
            <td>{{ product.quantity }}</td>
          </tr>
          <tr>
            <td colspan="2">Total Sales Quantity</td>
            <td class="total-quantity">{{ daily.totalProductSales }}</td>
          </tr>
          </tbody>
        </table>
        <div class="my-2" v-if="daily.isAvailableForExcelProductSales">
          <b-button size="md" variant="info" @click="downloadAsExcelDailyProductSales">
            Show Download's Optional Buttons
          </b-button>
          <b-button size="md" variant="outline-info" @click="printDailyBill(daily.productSales)" :disabled="daily.printBillLoading">
            <b-spinner small v-if="daily.printBillLoading"></b-spinner>
            <i class="icon-printer" v-else></i> Print Daily
          </b-button>
        </div>
      </div>
    </b-tab>
    <b-tab title="Monthly Report" class="text-center">
      <h4>Monthly Report</h4>
      <hr>
      <monthly-chart :date="month"/>
      <b-form inline>
        <datepicker
          v-model="month"
          :minimumView="'month'"
          :maximumView="'month'"
        />
        <b-button size="md" variant="success" @click="generateMonthlyReport">
          Generate Report
        </b-button>
      </b-form>
      <div class="table-container my-4" v-if="monthly.transactions.length > 0">
        <table class="table" id="table-monthly">
          <thead>
          <tr class="table-header">
            <td class="no">No</td>
            <td class="date">Transaction Date</td>
            <td class="total-sales">Total Sales</td>
            <td class="total-sales">Total Sales (After Tax)</td>
            <td class="sales-quantity">Sales Quantity</td>
            <td class="total-discount">Total Discounts</td>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(transaction, key) in monthly.transactions"
            v-bind:class="{ odd: key%2==0 }"
            :key="transaction.id"
          >
            <td class="no">{{ (key + 1) }}</td>
            <td class="date">{{ transaction.date }}</td>
            <td class="sub-price">{{ transaction.totalPrice | currency }}</td>
            <td class="sub-price">{{ transaction.totalFinalPrice | currency }}</td>
            <td class="sub-quantity">{{ transaction.totalQuantity }}</td>
            <td class="sub-discount">{{ transaction.totalDiscount | currency }}</td>
          </tr>
          <tr>
            <td colspan="2" class="right">
              Total
            </td>
            <td class="total-price">{{ this.monthly.totalPrice | currency }}</td>
            <td class="total-price">{{ this.monthly.totalFinalPrice | currency }}</td>
            <td class="total-quantity">{{ this.monthly.totalQuantity }}</td>
            <td class="total-discount">{{ this.monthly.totalDiscount | currency }}</td>
          </tr>
          </tbody>
        </table>
        <div class="my-2" v-if="monthly.isAvailableForExcel">
          <b-button size="md" variant="info" @click="downloadAsExcelMonthly">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
      <div class="my-4" v-else-if="monthly.transactions.length > 0" v-show="monthly.isLoaded">
        <h4>Oops, it looks like there are no transactions that can be shown</h4>
      </div>
      <div class="table-container my-4" v-if="monthly.productSales.length > 0">
        <table class="table" id="table-monthly-product-sales">
          <thead>
          <tr class="table-header text-center bold">
            <td colspan="3">Popular Products on {{ month | moment('MMMM YYYY') }} at {{ activeOutlet }}</td>
          </tr>
          </thead>
          <tbody>
          <tr class="table-header">
            <td class="no">No</td>
            <td class="date">Product/Beverages Name</td>
            <td class="total-sales">Sales Quantity</td>
          </tr>
          <tr
            v-for="(product, key) in monthly.productSales"
            v-bind:class="{ odd: key%2==0 }"
            :key="key"
          >
            <td>{{ (key + 1) }}</td>
            <td>{{ product.productName }}</td>
            <td>{{ product.quantity }}</td>
          </tr>
          <tr>
            <td colspan="2">Total Sales Quantity</td>
            <td class="total-quantity">{{ monthly.totalProductSales }}</td>
          </tr>
          </tbody>
        </table>
        <div class="my-2" v-if="monthly.isAvailableForExcelProductSales">
          <b-button size="md" variant="info" @click="downloadAsExcelMonthlyProductSales">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
    </b-tab>
    <b-tab title="Yearly Report" class="text-center">
      <h4>Yearly Report</h4>
      <hr>
      <yearly-chart :date="year"/>
      <b-form inline>
        <datepicker
          v-model="year"
          :minimumView="'year'"
          :maximumView="'year'"
        />
        <b-button size="md" variant="success" @click="generateYearlyReport">
          Generate Report
        </b-button>
      </b-form>
      <div class="table-container my-4" v-if="yearly.transactions.length > 0">
        <table class="table" id="table-monthly-2">
          <thead>
          <tr class="table-header">
            <td class="no">No</td>
            <td class="date">Transaction Month</td>
            <td class="total-sales">Total Sales</td>
            <td class="total-sales">Total Sales (After Tax)</td>
            <td class="sales-quantity">Sales Quantity</td>
            <td class="total-discount">Total Discounts</td>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(transaction, key) in yearly.transactions"
            v-bind:class="{ odd: key%2==0 }"
            :key="transaction.id"
          >
            <td class="no">{{ (key + 1) }}</td>
            <td class="date">{{ transaction.date | monthName}}</td>
            <td class="sub-price">{{ transaction.totalPrice | currency }}</td>
            <td class="sub-price">{{ transaction.totalFinalPrice | currency }}</td>
            <td class="sub-quantity">{{ transaction.totalQuantity }}</td>
            <td class="sub-discount">{{ transaction.totalDiscount | currency }}</td>
          </tr>
          <tr>
            <td colspan="2" class="right">
              Total
            </td>
            <td class="total-price">{{ this.yearly.totalPrice | currency }}</td>
            <td class="total-price">{{ this.yearly.totalFinalPrice | currency }}</td>
            <td class="total-quantity">{{ this.yearly.totalQuantity }}</td>
            <td class="total-discount">{{ this.yearly.totalDiscount | currency }}</td>
          </tr>
          </tbody>
        </table>
        <div class="my-2" v-if="yearly.isAvailableForExcel">
          <b-button size="md" variant="info" @click="downloadAsExcelMonthly">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
      <div class="my-4" v-else v-show="yearly.isLoaded">
        <h4>Oops, it looks like there are no transactions that can be shown</h4>
      </div>
    </b-tab>
    <b-tab title="Daily Report (Third Party)" class="text-center">
      <h4>Daily Report (Third Party)</h4>
      <hr>
      <b-form inline>
        <datepicker
          v-model="date"
        />
        <b-button size="md" variant="success" @click="generateDailyThirdPartyReport">
          Generate Report
        </b-button>
      </b-form>
      <div class="table-container my-4" v-if="dailyThirdParty.transactions.length > 0">
        <table class="table" id="table-daily-custom">
          <thead>
          <tr>
            <td>InvoiceNo</td>
            <td>Customer</td>
            <td>InvoiceDate</td>
            <td>DueDate</td>
            <td>Terms</td>
            <td>Location</td>
            <td>Memo</td>
            <td>Item(Product/Service)</td>
            <td>ItemDescription</td>
            <td>ItemQuantity</td>
            <td>ItemRate</td>
            <td>ItemAmount</td>
            <td>ItemTaxCode</td>
            <td>ItemTaxAmount</td>
            <td>ItemServiceFee</td>
            <td>Rounding</td>
            <td>Service Date</td>
          </tr>
          </thead>
          <tbody>
            <tr
              v-for="(transaction, key) in dailyThirdParty.transactions"
              :class="{ odd: key % 2==0 }"
            >
              <td>{{ transaction.InvoiceNo }}</td>
              <td>{{ transaction.Customer }}</td>
              <td>{{ transaction.InvoiceDate }}</td>
              <td>{{ transaction.DueDate }}</td>
              <td>{{ transaction.Terms }}</td>
              <td>{{ transaction.Location }}</td>
              <td>{{ transaction.Memo }}</td>
              <td>{{ transaction['Item(Product/Service)'] }}</td>
              <td>{{ transaction.ItemDescription }}</td>
              <td>{{ transaction.ItemQuantity }}</td>
              <td>{{ transaction.ItemRate | price }}</td>
              <td>{{ transaction.ItemAmount | price }}</td>
              <td>{{ transaction.ItemTaxCode }}</td>
              <td>{{ transaction.ItemTaxAmount }}</td>
              <td>{{ transaction.ItemServiceFee }}</td>
              <td>{{ transaction.Rounding }}</td>
              <td>{{ transaction['Service Date'].date }}</td>
          </tr>
          </tbody>
        </table>
        <div class="my-2" v-if="dailyThirdParty.isAvailableForExcel">
          <b-button size="md" variant="info" @click="downloadAsExcelDaily('custom')">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
      <div class="my-4" v-else-if="dailyThirdParty.transactions.length > 0" v-show="dailyThirdParty.isLoaded">
        <h4>Oops, it looks like there are no transactions that can be shown</h4>
      </div>
    </b-tab>
    <b-tab title="Date Range Report" class="text-center">
      <h4>Date Range Report</h4>
      <hr>
      <b-form inline>
        <datepicker
          v-model="dateStart"
        />
        <datepicker
          v-model="dateEnd"
          :disabled-dates="disabledDates"
        />
        <b-button size="md" variant="success" @click="generateDateRangeReport">
          Generate Report
        </b-button>
      </b-form>
      <div class="table-container my-4" v-if="dateRange.transactions.length > 0">
        <table class="table" id="table-date-range">
          <thead>
          <tr>
            <td rowspan="2">No</td>
            <td rowspan="2">Transaction Date</td>
            <td rowspan="2">Transaction ID</td>
            <td rowspan="2">Invoice Number</td>
            <td rowspan="2">Barista Name</td>
            <td rowspan="2">Payment Type</td>
            <td rowspan="2">Discount Reason</td>
            <td colspan="7">Detail</td>
            <td rowspan="2">Service Fee</td>
            <td rowspan="2">Rounding</td>
            <td rowspan="2">Grand Total</td>
          </tr>
          <tr>
            <td>Name</td>
            <td>Quantity</td>
            <td>Price</td>
            <td>Discount</td>
            <td>Adds On</td>
            <td>Tax</td>
            <td>Sub Total</td>
          </tr>
          </thead>
          <tbody>
          <template
            v-for="(transaction, key) in dateRange.transactions"
            :class="{ odd: key % 2==0 }"
          >
            <tr
              v-if="key !== 0"
              v-show="false"
              :key="transaction.id"
            >
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Name</td>
              <td>Quantity</td>
              <td>Price</td>
              <td>Discount</td>
              <td>Adds On</td>
              <td>Tax</td>
              <td>Sub Total</td>
              <td></td>
            </tr>
            <tr
              v-for="(product, idx) in transaction.products"
              :key="`${transaction.id}-${product.id}-${idx}`"
            >
              <td><template v-if="idx === 0">{{ key + 1 }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.created_at }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.id }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.invoice_number }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.user.name }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.payment }}</template></td>
              <td><template v-if="idx === 0">{{ transaction.discount_reason || '-' }}</template></td>
              <td class="text-left">{{ product.name }}</td>
              <td>{{ product.pivot.quantity }}</td>
              <td>{{ product.pivot.price | price }}</td>
              <td>{{ product.pivot.discount }} %</td>
              <td>{{ product.pivot.additional_price | price }}</td>
              <td>{{ product.pivot.tax }}</td>
              <td>{{ product.pivot.final_price | price }}</td>
              <td class="no-wrap"><template v-if="idx === 0">{{ transaction.service_fee }}</template></td>
              <td class="no-wrap"><template v-if="idx === 0">{{ transaction.rounding }}</template></td>
              <td class="no-wrap"><template v-if="idx === 0">{{ transaction.subTotal | currency }}</template></td>
            </tr>
          </template>
          <tr>
            <td colspan="15" class="text-right">
              Total Income
            </td>
            <td class="total-price no-wrap">
              {{ dateRange.totalPrice | currency }}
            </td>
          </tr>
          <template v-if="dateRange.paymentMethods">
            <tr v-for="(method, index) in dateRange.paymentMethods" :key="index">
              <td colspan="15" class="text-right">
                Total {{ method.name }}
              </td>
              <td class="total-price no-wrap">
                {{ method.value | currency }}
              </td>
            </tr>
          </template>
          </tbody>
        </table>
        <div class="my-2" v-if="dateRange.isAvailableForExcel">
          <b-button size="md" variant="info" @click="downloadAsExcelDateRange()">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
      <div class="my-4" v-else-if="dateRange.transactions.length > 0" v-show="dateRange.isLoaded">
        <h4>Oops, it looks like there are no transactions that can be shown</h4>
      </div>
      <div class="table-container my-4" v-if="dateRange.categorySales.length > 0">
        <table class="table" id="table-date-range-category-sales">
          <thead>
          <tr class="table-header text-center bold">
            <td colspan="5" class="center">Popular Categories at {{ activeOutlet }}</td>
          </tr>
          </thead>
          <tbody>
          <tr class="table-header">
            <td class="no">No</td>
            <td class="date">Primary</td>
            <td class="date">Secondary</td>
            <td class="date">Tertiary</td>
            <td class="total-sales qty">Quantity</td>
          </tr>
          <template v-for="(category, key) in dateRange.categorySales">
            <tr :class="{ odd: key % 2 === 0 }" :key="key" class="level-1">
              <td>{{ (key + 1) }}</td>
              <td>{{ category.categoryName }} <small>({{ category.total_sales | currency }})</small></td>
              <td colspan="3" class="qty">{{ category.total }}</td>
            </tr>
            <template v-if="category.children && category.children.length" v-for="(child, childKey) in category.children">
              <tr :class="{ odd: key % 2 === 0 }" :key="childKey" class="level-2">
                <td colspan="2" class="qty">↳</td>
                <td>{{ child.categoryName }} <small>({{ child.total_sales | currency }})</small></td>
                <td colspan="2" class="qty">{{ child.total }}</td>
              </tr>
              <template v-if="child.children && child.children.length">
                <tr :class="{ odd: key % 2 === 0 }" v-for="(grandChild, grandChildKey) in child.children"
                    :key="grandChildKey" class="level-3">
                  <td colspan="3" class="qty">↳</td>
                  <td>{{ grandChild.categoryName }} <small>({{ grandChild.total_sales | currency }})</small></td>
                  <td class="qty">{{ grandChild.total }}</td>
                </tr>
              </template>
            </template>
          </template>
          </tbody>
        </table>
        <div class="my-2" v-if="dateRange.isAvailableForExcelCategorySales">
          <b-button size="md" variant="info" @click="downloadAsExcelDateRangeCategorySales">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
      <div class="table-container my-4" v-if="dateRange.productSales.length > 0">
        <table class="table" id="table-date-range-product-sales">
          <thead>
          <tr class="table-header text-center bold">
            <td colspan="3">Popular Products on {{ dateStart | moment('MMMM YYYY') }} - {{ dateEnd | moment('MMMM YYYY')}} at {{ activeOutlet }}</td>
          </tr>
          </thead>
          <tbody>
          <tr class="table-header">
            <td class="no">No</td>
            <td class="date">Product/Beverages Name</td>
            <td class="total-sales">Sales Quantity</td>
          </tr>
          <tr
            v-for="(product, key) in dateRange.productSales"
            v-bind:class="{ odd: key%2==0 }"
            :key="key"
          >
            <td>{{ (key + 1) }}</td>
            <td>{{ product.productName }}</td>
            <td>{{ product.quantity }}</td>
          </tr>
          <tr>
            <td colspan="2">Total Sales Quantity</td>
            <td class="total-quantity">{{ dateRange.totalProductSales }}</td>
          </tr>
          </tbody>
        </table>
        <div class="my-2" v-if="dateRange.isAvailableForExcelProductSales">
          <b-button size="md" variant="info" @click="downloadAsExcelDateRangeProductSales">
            Show Download's Optional Buttons
          </b-button>
        </div>
      </div>
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import moment from 'moment'
import MonthlyChart from '@/components/Dashboard/MonthlyChart'
import YearlyChart from '@/components/Dashboard/YearlyChart'
import TableExport from 'tableexport'
import { getDaily, getDailyThirdParty, getDailyProductSales, getMonthly, getMonthlyProductSales, getYearly, getDateRange, getDateRangeCategorySales, getDateRangeProductSales, printDailyBill, syncToHarmony } from '@/services/dashboard'

export default {
  name: 'dashboard',
  components: {
    MonthlyChart,
    YearlyChart
  },
  data () {
    return {
      date: new Date(),
      month: new Date(),
      year: new Date(),
      dateStart: new Date(),
      dateEnd: new Date(),
      daily: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        paymentMethods: [],
        printBillLoading: false,
        syncToHarmonyLoading: false
      },
      dailyThirdParty: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        paymentMethods: [],
        printBillLoading: false
      },
      monthly: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        totalQuantity: -1,
        totalDiscount: -1,
        totalProductSales: -1
      },
      yearly: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        totalQuantity: -1,
        totalDiscount: -1,
        totalProductSales: -1
      },
      dateRange: {
        transactions: [],
        productSales: [],
        categorySales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isAvailableForExcelCategorySales: false,
        isLoaded: false,
        totalPrice: -1,
        paymentMethods: [],
        totalProductSales: -1
      },
      tableExport: null
    }
  },
  computed: {
    monthDate: function () {
      return this.moment(this.month, 'YYYY-MM')
    },
    activeOutlet: function () {
      return this.$store.state.auth.isAllOutlet ? 'All Outlet' : this.$store.getters.outlet.name
    },
    disabledDates () {
      return {
        to: this.dateStart
      }
    }
  },
  methods: {
    generateDailyReport () {
      getDaily(this.moment(this.date))
        .then((response) => {
          this.daily.transactions = response.transactions
          this.daily.isAvailableForExcel = true
          this.daily.isLoaded = true
          this.daily.totalPrice = response.totalFinalPrice
          if (response.totalPerPaymentMethod) {
            this.daily.paymentMethods = Object.keys(response.totalPerPaymentMethod)
              .map(data => ({ name: data, value: response.totalPerPaymentMethod[data] }))
          }
          this.removeAllButtonForExportDaily()
          this.removeAllButtonForExportDailyCustom()
        })
        .catch((e) => {
          this.$toast('failed to fetch daily transactions on ' + this.date)
          this.daily.transactions = []
        })
      getDailyProductSales(this.moment(this.date))
        .then((response) => {
          this.daily.productSales = Object.keys(response).map(function (key) {
            return response[key]
          })
          this.daily.productSales.sort((a, b) => b.quantity - a.quantity)
          this.daily.isAvailableForExcelProductSales = true
          this.calculateAllTotalDailyProductSalesQuantity()
          this.removeAllButtonForExportDailyProductSales()
        })
        .catch((e) => {
          this.$toast('failed to fetch daily sales on ' + this.day)
          this.daily.productSales = []
        })
    },
    generateDailyThirdPartyReport () {
      getDailyThirdParty(this.moment(this.date))
        .then((response) => {
          this.dailyThirdParty.transactions = response.transactions
          this.dailyThirdParty.isAvailableForExcel = true
          this.dailyThirdParty.isLoaded = true
          this.dailyThirdParty.totalPrice = response.totalFinalPrice
          if (response.totalPerPaymentMethod) {
            this.dailyThirdParty.paymentMethods = Object.keys(response.totalPerPaymentMethod)
              .map(data => ({ name: data, value: response.totalPerPaymentMethod[data] }))
          }
          this.removeAllButtonForExportDaily()
          this.removeAllButtonForExportDailyCustom()
        })
        .catch((e) => {
          this.$toast('failed to fetch daily transactions on ' + this.date)
          this.dailyThirdParty.transactions = []
        })
    },
    generateMonthlyReport () {
      getMonthly(this.monthDate)
        .then((response) => {
          this.monthly.transactions = response
          this.monthly.isAvailableForExcel = true
          this.monthly.isLoaded = true
          this.calculateAllTotalAttributesMonthly()
          this.removeAllButtonForExportMonthly()
        })
        .catch((e) => {
          this.$toast('failed to fetch monthly transactions on ' + this.month)
          this.month.transaction = []
        })
      getMonthlyProductSales(this.monthDate)
        .then((response) => {
          this.monthly.productSales = Object.keys(response).map(function (key) {
            return response[key]
          })
          this.monthly.productSales.sort((a, b) => b.quantity - a.quantity)
          this.monthly.isAvailableForExcelProductSales = true
          this.calculateAllTotalMonthlyProductSalesQuantity()
          this.removeAllButtonForExportMonthlyProductSales()
        })
        .catch((e) => {
          this.$toast('failed to fetch monthly sales on ' + this.month)
          this.monthly.productSales = []
        })
    },
    generateYearlyReport () {
      getYearly(this.moment(this.year, 'YYYY-MM'))
        .then((response) => {
          this.yearly.transactions = response
          this.yearly.isAvailableForExcel = true
          this.yearly.isLoaded = true
          this.calculateAllTotalAttributesYearly()
          this.removeAllButtonForExportMonthly()
        })
        .catch((e) => {
          this.$toast('failed to fetch year transactions on ' + this.year)
          this.yearly.transaction = []
        })
    },
    generateDateRangeReport () {
      getDateRange(this.moment(this.dateStart), this.moment(this.dateEnd))
        .then((response) => {
          this.dateRange.transactions = response.transactions
          this.dateRange.isAvailableForExcel = true
          this.dateRange.isAvailableForExcelCategorySales = true
          this.dateRange.isLoaded = true
          this.dateRange.totalPrice = response.totalFinalPrice
          if (response.totalPerPaymentMethod) {
            this.dateRange.paymentMethods = Object.keys(response.totalPerPaymentMethod)
              .map(data => ({ name: data, value: response.totalPerPaymentMethod[data] }))
          }
          this.removeAllButtonForExportDateRange()
        })
        .catch((e) => {
          this.$toast(`failed to fetch date range transactions on ${this.dateStart} - ${this.dateEnd}`)
          this.daily.transactions = []
        })
      getDateRangeCategorySales(this.moment(this.dateStart), this.moment(this.dateEnd))
        .then((response) => {
          console.log(response)
          this.dateRange.categorySales = response.data
        })
      getDateRangeProductSales(this.moment(this.dateStart), this.moment(this.dateEnd))
        .then((response) => {
          this.dateRange.productSales = Object.keys(response).map(function (key) {
            return response[key]
          })
          this.dateRange.productSales.sort((a, b) => b.quantity - a.quantity)
          this.dateRange.isAvailableForExcelProductSales = true
          this.calculateAllTotalDateRangeProductSalesQuantity()
          this.removeAllButtonForExportDateRangeProductSales()
        })
        .catch((e) => {
          this.$toast(`failed to fetch date range sales on ${this.dateStart} - ${this.dateEnd}`)
          this.dateRange.productSales = []
        })
    },
    downloadAsExcelDaily: function (custom = false) {
      const elementId = custom ? 'table-daily-custom' : 'table-daily'
      this.tableExport = TableExport(document.getElementById(elementId), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Daily Report-' + moment(this.date).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.daily.isAvailableForExcel = false
    },
    downloadJson: function () {
      getDaily(this.moment(this.date))
        .then((response) => {
          const dataStr = JSON.stringify(response, null, 2)
          const blob = new Blob([dataStr], { type: 'application/json' })
          const url = URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.download = 'Daily Report-' + moment(this.date).format('DDMMYYYY') + 'data.json'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        })
        .catch((e) => {
          this.$toast('failed to download daily transactions on ' + this.date)
          this.daily.transactions = []
        })
    },
    downloadAsExcelMonthly: function () {
      this.tableExport = TableExport(document.getElementById('table-monthly'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Monthly Report-' + this.month,
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.monthly.isAvailableForExcel = false
    },
    downloadAsExcelDailyProductSales: function () {
      this.tableExport = TableExport(document.getElementById('table-daily-product-sales'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Daily Sales Report-' + moment(this.date).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.daily.isAvailableForExcelProductSales = false
    },
    downloadAsExcelMonthlyProductSales: function () {
      this.tableExport = TableExport(document.getElementById('table-monthly-product-sales'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Monthly Sales Report-' + this.month,
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.monthly.isAvailableForExcelProductSales = false
    },
    downloadAsExcelDateRange: function () {
      const elementId = 'table-date-range'
      this.tableExport = TableExport(document.getElementById(elementId), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Date Range Report-' + moment(this.dateStart).format('DDMMYYYY') + '~' + moment(this.dateEnd).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.daily.isAvailableForExcel = false
    },
    downloadAsExcelDateRangeCategorySales: function () {
      const elementId = 'table-date-range-category-sales'
      this.tableExport = TableExport(document.getElementById(elementId), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Date Range Category Sales Report-' + moment(this.dateStart).format('DDMMYYYY') + '~' + moment(this.dateEnd).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.monthly.isAvailableForExcelCategorySales = false
    },
    downloadAsExcelDateRangeProductSales: function () {
      this.tableExport = TableExport(document.getElementById('table-date-range-product-sales'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Date Range Sales Report-' + this.month,
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      })
      this.dateRange.isAvailableForExcelProductSales = false
    },
    removeAllButtonForExportDaily () {
      let parent = document.getElementById('table-daily')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    removeAllButtonForExportDailyCustom () {
      let parent = document.getElementById('table-daily-custom')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    removeAllButtonForExportMonthly () {
      let parent = document.getElementById('table-monthly')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    removeAllButtonForExportDateRange () {
      let parent = document.getElementById('table-date-range')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    removeAllButtonForExportDailyProductSales () {
      let parent = document.getElementById('table-daily-product-sales')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    removeAllButtonForExportMonthlyProductSales () {
      let parent = document.getElementById('table-monthly-product-sales')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    removeAllButtonForExportDateRangeProductSales () {
      let parent = document.getElementById('table-date-range-product-sales')
      let child = document.getElementsByTagName('caption')[0]
      if (child != null) {
        parent.removeChild(child)
      }
    },
    calculateAllTotalAttributesMonthly () {
      let totalPrice = 0
      let totalFinalPrice = 0
      let totalQuantity = 0
      let totalDiscount = 0
      for (let transaction of this.monthly.transactions) {
        totalPrice += parseFloat(transaction.totalPrice)
        totalFinalPrice += parseFloat(transaction.totalFinalPrice)
        totalQuantity += transaction.totalQuantity
        totalDiscount += parseFloat(transaction.totalDiscount)
      }
      this.monthly.totalPrice = parseFloat(totalPrice).toFixed(2)
      this.monthly.totalFinalPrice = parseFloat(totalFinalPrice).toFixed(2)
      this.monthly.totalQuantity = parseInt(totalQuantity)
      this.monthly.totalDiscount = parseFloat(totalDiscount).toFixed(2)
    },
    calculateAllTotalAttributesYearly () {
      let totalPrice = 0
      let totalFinalPrice = 0
      let totalQuantity = 0
      let totalDiscount = 0
      for (let transaction of this.yearly.transactions) {
        totalPrice += parseFloat(transaction.totalPrice)
        totalFinalPrice += parseFloat(transaction.totalFinalPrice)
        totalQuantity += transaction.totalQuantity
        totalDiscount += parseFloat(transaction.totalDiscount)
      }
      this.yearly.totalPrice = parseFloat(totalPrice).toFixed(2)
      this.yearly.totalFinalPrice = parseFloat(totalFinalPrice).toFixed(2)
      this.yearly.totalQuantity = parseInt(totalQuantity)
      this.yearly.totalDiscount = parseFloat(totalDiscount).toFixed(2)
    },
    calculateAllTotalDailyProductSalesQuantity () {
      let totalQuantity = 0
      for (let product of this.daily.productSales) {
        totalQuantity += parseInt(product.quantity)
      }
      this.daily.totalProductSales = totalQuantity
    },
    calculateAllTotalMonthlyProductSalesQuantity () {
      let totalQuantity = 0
      for (let product of this.monthly.productSales) {
        totalQuantity += parseInt(product.quantity)
      }
      this.monthly.totalProductSales = totalQuantity
    },
    calculateAllTotalDateRangeProductSalesQuantity () {
      let totalQuantity = 0
      for (let product of this.dateRange.productSales) {
        totalQuantity += parseInt(product.quantity)
      }
      this.dateRange.totalProductSales = totalQuantity
    },
    printDailyBill (products) {
      this.daily.printBillLoading = true
      const mappedProducts = products.map(product => ({ name: product.productName,
        price: product.price,
        quantity: product.quantity,
        discount: 0
      }))
      printDailyBill({ id: this.date, date: this.date, products: mappedProducts })
        .then((response) => {
          this.daily.printBillLoading = false
        })
        .catch((e) => {
          this.$toast('failed to print daily bill')
          this.daily.printBillLoading = false
        })
    },
    syncToHarmony () {
      this.daily.syncToHarmonyLoading = true
      syncToHarmony({ date: this.date })
        .then((response) => {
          console.log(response)
        })
        .catch((e) => {
          this.$toast('failed to sync to harmony for date ' + this.date)
          this.yearly.transaction = []
        })
        .finally(() => {
          this.daily.syncToHarmonyLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .table {
    width: 100%;
    text-align: left;
    border: 1px solid #c2cfd6;
    -webkit-font-smoothing: antialiased;
  }
  .table td {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    text-align: center;
  }

  .table td.no-wrap {
    white-space: nowrap;
  }

  .table-header {
    font-weight: 400;
    border: 1px solid #c2cfd6;
    cursor: pointer;
  }
  .bold {
    font-weight: bold;
  }
  .table tr {
    border-bottom: 1px solid #c2cfd6;
  }
  .no {
    width: 50px;
  }
  .date {
    min-width: 200px;
  }
  .total-sales {
    min-width: 200px;
  }
  .sales-quantity {
    min-width: 200px;
  }
  .products {
    min-width: 300px;
    min-height: 50px;
    word-wrap: break-word;
  }
  .sub-total-price {
    min-width: 150px;
  }
  .total-price {
    font-weight: bold;
  }
  .total-quantity {
    font-weight: bold;
  }
  .total-discount {
    font-weight: bold;
  }
  .right {
    text-align: right;
  }
  .odd {
    background: #f0f3f5;
  }
  #table-date-range-category-sales {
    td {
      text-align: left;
    }
    .qty {
      text-align: right;
    }
    .center {
      text-align: center;
    }
    .level-1 {
      font-weight: 800;
    }
    .level-2 {
      font-weight: 600;
    }
    .level-3 {
      font-weight: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue